function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "2 2 16 16"
}, props), React.createElement("path", {
  d: "M11.6 13.1l-2 2.5c-.3.3-.7.3-.9 0-.1-.1-.2-.3-.2-.5v-2c-2.5-.5-4-2.3-4-4.4 0-2.5 2.1-4.5 5.5-4.5s5.5 2 5.5 4.5c-.1 2.3-1.7 4.1-3.9 4.4z"
})));